
import styled from "styled-components";

export default function ClaimTip({ from, to,intl }) {

  return (
    <Wrapper>
      
      {intl.formatMessage({
          id: "pages.account.profit_harvest_tip3",
          defaultMessage: "将收获",
        })}
      <br />
      <span>{from}-{to}</span>
      <br />
      {intl.formatMessage({
          id: "pages.account.profit_harvest_tip4",
          defaultMessage: "产生的所有收益，如果您选取的时间跨度过大，交易可能失败，是否收获？",
        })}
      
    </Wrapper>
  );
}

const Wrapper = styled.div`

font-style: normal;
font-weight: 500;
font-size: 1.6rem;
line-height: 2.4rem;
color: #000000;
text-align: center;
span {
  color: #FF5C00;
}
`;
